import { Injectable } from '@angular/core';
import liff from '@line/liff';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly _isLogin$ = new BehaviorSubject<boolean>(false);
  readonly isLogin$: Observable<boolean> = this._isLogin$.asObservable();

  get isLogin(): boolean {
    return this._isLogin$.value;
  }
  set isLogin(value: boolean) {
    this._isLogin$.next(value);
  }

  loaded: boolean = false;

  token: string = '';
  user: { userId: string; displayName: string; pictureUrl: string; statusMessage: string; role?: string | null } | undefined;

  authEndpoint: string = environment.authEndpoint;

  constructor(
    private http: HttpClient
  ) { }

  getAPIAuthEndPoint() {
    return this.authEndpoint;
  }

  logout() {
    return new Promise(async (resolve, reject) => {
      const liffId: string = environment.liffId;
      liff.init({ liffId }).then(() => {
        liff.logout()
        localStorage.removeItem('user')
        localStorage.removeItem('method')
        resolve(true)
        window.location.reload();
      })
    })
  }

  async getAccessToken(user_id: string, channel: string, info: any): Promise<any> {
    const result: any = await firstValueFrom(
      this.http.post(`${this.authEndpoint}/auth/token`, { user_id, channel, info })
    );
    this.token = result.access_token;
    return result;
  }

  getUserInfo() {
    const systemId = environment.systemId;
    return firstValueFrom(this.http.get(`${this.authEndpoint}/user/info?system_id=${systemId}`));
  }

  getUserRequest() {
    const systemId = environment.systemId;
    return firstValueFrom(this.http.get(`${this.authEndpoint}/request/one?system_id=${systemId}`));
  }

  requestAccess(body: any) {
    return firstValueFrom(this.http.post(`${this.authEndpoint}/request/create`, body));
  }

  getAllUserRequest() {
    const systemId = environment.systemId;
    return firstValueFrom(this.http.get(`${this.authEndpoint}/request/all?system_id=${systemId}`));
  }

  getAllUserInfo() {
    const systemId = environment.systemId;
    return firstValueFrom(this.http.get(`${this.authEndpoint}/user/info/all?system_id=${systemId}`));
  }

  updatePermission(body: any) {
    return firstValueFrom(this.http.patch(`${this.authEndpoint}/user/update-permissions`, body));
  }

  updateRoleMemberSelected(body: any) {
    return firstValueFrom(this.http.patch(`${this.authEndpoint}/user/update-role-member`, body));
  }

  updateLineInfo(body: { userId: string; displayName: string; pictureUrl: string; statusMessage: string; }) {
    return firstValueFrom(this.http.patch(`${this.authEndpoint}/user/update-line-info`, body));
  }

}
